import { projects as generatedProjects } from "../generated/projects";
import { getAllPosts } from "./posts";

export interface ProjectMetadata {
  slug: string;
  title: string;
  description: string;
  startDate: string;
  status: string;
  tags: string[];
  github: string;
  blogPosts: string[];
}

export interface Project extends ProjectMetadata {
  content: string;
  htmlContent: string;
}

export async function getAllProjects(): Promise<ProjectMetadata[]> {
  return generatedProjects.map(p => ({
    slug: p.slug,
    title: p.title,
    description: p.description,
    startDate: p.startDate,
    status: p.status,
    tags: p.tags,
    github: p.github,
    blogPosts: p.blogPosts,
  }));
}

export async function getProjectBySlug(slug: string): Promise<Project | null> {
  const project = generatedProjects.find(p => p.slug === slug);
  return project || null;
}

export async function getRelatedPosts(projectSlug: string) {
  const project = generatedProjects.find(p => p.slug === projectSlug);
  if (!project) return [];

  const allPosts = await getAllPosts();
  return allPosts.filter(post => project.blogPosts.includes(post.slug));
}

export function formatDateRange(startDate: string): string {
  if (!startDate) return "";
  const start = new Date(startDate);
  const now = new Date();
  const months = (now.getFullYear() - start.getFullYear()) * 12 + (now.getMonth() - start.getMonth());
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  const startStr = start.toLocaleDateString("en-US", { year: "numeric", month: "short" });

  if (years > 0) {
    return `${startStr} — Present · ${years}yr${remainingMonths > 0 ? ` ${remainingMonths}mo` : ""}`;
  }
  return `${startStr} — Present · ${months}mo`;
}
